import { t as translate } from 'i18n';
const DAY = 24 * 60 * 60 * 1000;
const GROUPS = () => ([
  { id: 'today', label: translate('assistant.conversationHistoryToday') },
  { id: 'yesterday', label: translate('assistant.conversationHistoryYesterday') },
  { id: 'week', label: translate('assistant.conversationHistoryLast7Days') },
  { id: 'month', label: translate('assistant.conversationHistoryThisMonth') },
  { id: 'older', label: translate('assistant.conversationHistoryEarlier') },
]);

// Calendar dates in the browser's timezone, without 23/25-hour DST days.
const dayOf = (date) => Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

export function groupConversations(items, now = new Date()) {
  const grouped = new Map(GROUPS().map((group) => [group.id, { ...group, items: [] }]));
  for (const item of items) {
    const date = new Date(item.last_activity_at);
    const age = Math.round((dayOf(now) - dayOf(date)) / DAY);
    const group = Number.isNaN(date.getTime()) ? 'older' : age <= 0 ? 'today' : age === 1 ? 'yesterday' : age < 7 ? 'week'
      : date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear() ? 'month' : 'older';
    grouped.get(group).items.push(item);
  }
  return Array.from(grouped.values()).filter((group) => group.items.length > 0);
}

export function filterConversations(items, search) {
  const term = search.trim().toLocaleLowerCase('ru-RU');
  return term ? items.filter((item) => `${item.title || ''} ${item.preview || ''}`.toLocaleLowerCase('ru-RU').includes(term)) : items;
}

export function conversationPreview(item) {
  const preview = (item.preview || '').trim();
  const title = (item.title || '').replace(/…$/, '').trim();
  return !preview || (title && preview.startsWith(title)) ? '' : preview;
}
